import { StandardButton } from '@/components/buttons';
import { Flex, Input, Title } from '@mantine/core';
import { IconArrowLeft } from '@tabler/icons-react';
import { useState } from 'react';
import { useBaleCreateContext } from '../hook';
import styles from '../styles.module.css';

export const BaleCreateManualCodeEntryPage = () => {
	const { handleScan, setPage } = useBaleCreateContext();
	const [code, setCode] = useState('');

	return (
		<Flex
			pos="absolute"
			h="100vh"
			w="100%"
			className={`${styles.pageBackground} ${styles.pageContentWithHeader}`}
		>
			<Flex
				pos="fixed"
				top={0}
				left={0}
				px="md"
				py="lg"
				bg="white"
				w="100%"
				align="center"
				gap="sm"
			>
				<IconArrowLeft onClick={() => setPage('SCAN')} />
				<Title order={2}>Enter Code Manually</Title>
			</Flex>
			<Flex px="lg" pt="xl" w="100%" direction="column" gap="lg">
				<Input
					size="lg"
					w="100%"
					placeholder="Enter Code"
					value={code}
					onChange={(e) => setCode(e.target.value)}
				/>
				<StandardButton onClick={() => handleScan(code)} variant="filled">
					Enter
				</StandardButton>
			</Flex>
			<Flex pos="fixed" bottom={0} left={0} p="md" bg="white" w="100%" align="center" gap="sm" />
		</Flex>
	);
};
